import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { Match } from '@atlassian/react-resource-router';
import parameters from '@atlassian/jira-relay/src/__generated__/WorkItemEntrypointUiQuery$parameters';

const getIssueKey = (match: Match) => {
	return match?.params?.issueKey?.length ? match.params.issueKey : null;
};

const extractProjectKey = (issueKey: string): string => issueKey.split('-')[0];

export const workItemEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-work-item-view-entrypoint" */ './src/ui/WorkItemSanitisedEntrypoint.tsx'
			),
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const { match } = context;
		const issueKey = getIssueKey(match);

		const projectKey = issueKey ? extractProjectKey(issueKey) : '';
		// Construct JQL to search for issues in this project
		const jql = projectKey ? `project = "${projectKey}"` : '';
		const queryVariables = {
			cloudId: cloudId || '',
			issueKey: issueKey || '',
			projectKey,
			jql,
		};

		return {
			queries: {
				workItemQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					variables: {
						...queryVariables,
					},
					parameters,
				},
			},
		};
	},
});
